import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserInfoService } from '@ecap3/core';

@Component({
    selector: 'app-platform-no-data-found',
    templateUrl: './no-data-found.component.html',
    styleUrls: ['./no-data-found.component.scss']
})
export class NoDataFoundComponent implements OnInit {
    @Input() noDataFoundMessage: string;
    @Input() noDataFoundIcon: any;
    @Input() noDataFound: NodataFoundConfiguration;
    @Output() onClickNoDataButton: EventEmitter<any> = new EventEmitter<any>();

    userData: any;
    role: string;
    paramId: any;

    constructor(
        private userInfoService: UserInfoService
    ) {
    }

    ngOnInit() {
        this.userData = this.userInfoService.getUserInfo();
    }

    onClickButton() {
        this.onClickNoDataButton && this.onClickNoDataButton.emit();
    }
}


export interface NodataFoundConfiguration {
    templateName: any,
    noDataLargeTitle: any,
    noDataSmallTitle: any,
    noDataMessage: any,
    matIconClass: any,
    slNetworkIcon: any,
    routeLink: any,
    noDataButtonText: any,
    buttonIcon: any,
    iconHeightClass: any,
    iconWidthClass: any,
    iconFontSizeClass: any,
    customClass: any,
    button: boolean,
    smTitleFontSize: any,
    lgTitleFontSize: any,
    featureGuardEnable: any
}